// Administration API — report log, independent verification, DB sessions.
const API = process.env.REACT_APP_API_URL || "http://localhost:8002";

async function j(res) {
  if (!res.ok) {
    let detail = res.statusText;
    try { detail = (await res.json()).detail || detail; } catch {}
    throw new Error(detail);
  }
  return res.json();
}

export const fetchReportLog = () =>
  fetch(`${API}/api/admin/report-log`).then(j);

export const clearReportLog = () =>
  fetch(`${API}/api/admin/report-log/clear`, { method: "POST" }).then(j);

export const verifyReport = (logId) =>
  fetch(`${API}/api/admin/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ log_id: logId }),
  }).then(j);

export const fetchSessions = () =>
  fetch(`${API}/api/admin/sessions`).then(j);
